import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/form/enquiry/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import { DOWNLOAD_EXCEL } from "../../../../utils/Methods";

const Country = () => {
  const dispatch = useDispatch();

  const {
    country,
    f_name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  useEffect(() => {
    if (country?.data?.data) {
      const newIds = country?.data?.data?.map((d) => d.id);
      setAllChecked(newIds);
    }
  }, [country?.data]);

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleDelete = async (id) => {
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    await fetch();
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await DOWNLOAD_EXCEL(
          "/admin/enquiry/download",
          selectAllChecked,
          "Enquiry List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Enquiry" alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={f_name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by First Name</label>
              <Form.Control
                type="text"
                placeholder="Enter First Name"
                value={f_name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                }}
              >
                Reset
              </button>
            </div>
            <div className="mb-3">
              {/* <CButton name="Reset" variant="danger" action={handleReset} /> */}
              {/* <CButton name="Add" variant="success" action={() => setAdd(true)} /> */}
              <button className="btn btn-success " onClick={HandleDownload}>
                Download Excel
              </button>
            </div>{" "}
          </div>
        </div>
      </div>

      {/* <Add id={id} setId={setId} /> */}

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    value="selectAll"
                    checked={allChecked.length === selectAllChecked.length}
                    onChange={handleChange}
                    id="selectAll"
                    className="me-1"
                  ></input>
                  Select
                </th>
                <th>S. no.</th>
                <th>User Type</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Contact No</th>
                <th>Message</th>
                <th>Date</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {country?.data?.data?.length > 0 ? (
                country?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={val?.id}
                        name="perselected"
                        checked={selectAllChecked.includes(val?.id)}
                        onChange={handleChange}
                        id="flexCheckDefault"
                      />
                    </td>{" "}
                    <td>
                      {(country?.data?.current_page - 1) *
                        country?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.user_type || "-"}</td>
                    <td>{val?.f_name}</td>
                    <td>{val?.l_name}</td>
                    <td>{val?.email}</td>
                    <td>{val?.contact_no}</td>
                    <td>{val?.message}</td>
                    <td>
                      {new Date(val?.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        // hour: "2-digit",
                        // minute: "2-digit",
                        // hour12: true,
                      })}
                    </td>
                    {/* <td>
                      <div className="action_btns">
                        <button type="button" className="editbtn">
                          <Link>
                            <img
                              className="icon"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icons/view.png"
                              }
                            />
                          </Link>
                        </button>
                        <button
                          type="button"
                          className="editbtn"
                          onClick={() => setId(val?.id)}
                        >
                          <Link>
                            <img
                              className="icon"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icons/edit.png"
                              }
                            />
                          </Link>
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Pagination_Holder
        onPageChange={country?.data?.current_page}
        totalPages={country?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Country;
